import { useCallback } from 'react';

export const useKeyboardShortcutHandler = ({
  active,
  images,
  changeImage,
  hideLightbox,
}) => {
  const handleShortcut = useCallback(
    (key, e) => {
      if (!active) return;

      if (typeof document === 'undefined') return;

      e.preventDefault();
      const index = _.findIndex(images, ['id', active]);

      if (index !== 0 && (key === 'up' || key === 'left')) {
        changeImage(index - 1);
      } else if (
        index !== _.size(images) - 1 &&
        (key === 'down' || key === 'right')
      ) {
        changeImage(index + 1);
      } else if (key === 'esc') {
        hideLightbox();
      }
    },
    [active, images, changeImage, hideLightbox]
  );

  return { handleShortcut };
};
